import { createVoxVivaVuetify } from "~/vvVuetify";
import { getDefaultThemeForVuetify } from "~/themeSync";

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(createVoxVivaVuetify(getDefaultThemeForVuetify()));
});
